import { Box, styled, Tab, Tabs } from '@material-ui/core';
import { PlanDurations } from './ManagePlan';
import { PlanCard } from './PlanCard';
import { PlanDetailsProps } from './PlanForm';
import { useEffect, useState, } from 'react';
import { Grid } from '@mui/material';

const DurationTabs = styled(Tabs)({
    '& .MuiTabs-indicator': {
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-flexContainer': {
        width: 'fit-content',
        padding: '5px 5px',
        borderRadius: 24,
        backgroundColor: '#80808059',
        color: 'black'
    },
});

const DurationTab = styled((label: any) => (
    <Tab disableRipple {...label} />
))(({ theme }) => ({
    textTransform: 'capitalize',
    width: 70,
    minHeight: 29,
    borderRadius: 24,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    fontWeight: 600,
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.85)',
    fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"'].join(','),
    '&.Mui-selected': {
        color: 'black',
        backgroundColor: 'white',
        fontWeight: 600,
    },
    '&.Mui-focusVisible': {
        backgroundColor: '#d1eaff',
    },
}));


export const ListPlans = ({ plans, actions }: { plans: PlanDetailsProps[], actions: any }) => {
    const [activeDuration, setActiveDuration] = useState(PlanDurations.MONTHLY);
    const [filteredPlan, setFilteredPlan] = useState([]);

    useEffect(() => {
        if (!plans) return;

        const filtered: any = plans.filter(plan =>
            plan.pricings.some(pricing => pricing.duration === activeDuration)
        );

        setFilteredPlan(filtered);
    }, [activeDuration]);



    return (
        <Box width="100%">
            <Box style={{ display: 'flex', justifyContent: 'center' }}>
                <DurationTabs
                    value={activeDuration}
                    onChange={(e: any) => { setActiveDuration(e?.target?.innerText.toLowerCase()); }} // You may want to implement a handler here
                >
                    {Object.values(PlanDurations).map((duration) => (
                        <DurationTab key={duration} value={duration} label={duration} />
                    ))}
                </DurationTabs>
            </Box>

            <Grid container spacing={3} mt={2}>
                {filteredPlan?.map((plan: any) => (
                    <Grid item md={4} key={plan?.id || plan?.name}>
                        {
                            <PlanCard plan={plan} duration={activeDuration} actions={actions} />
                        }
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

